import { useEffect, useState } from "react";
import { passengerApi } from "@/lib/passengerApi";

let _cache = null;
let _cacheAt = 0;
let _inflight = null;
const CACHE_TTL_MS = 5 * 60 * 1000;  // 5 min — keeps admin-config updates visible quickly

/**
 * Fetches /api/passenger/meta (categories, depots, doc requirements,
 * card_fee + deposit config) and caches it for 5 minutes. All MajheApp
 * screens share the same instance.
 */
export function useMajheMeta() {
  const now = Date.now();
  const fresh = _cache && now - _cacheAt < CACHE_TTL_MS;
  const [meta, setMeta] = useState(fresh ? _cache : null);
  const [loading, setLoading] = useState(!fresh);

  useEffect(() => {
    if (fresh) return;
    if (!_inflight) {
      _inflight = passengerApi.get("/meta")
        .then((r) => { _cache = r.data; _cacheAt = Date.now(); return r.data; })
        .catch(() => null)
        .finally(() => { _inflight = null; });
    }
    _inflight.then((data) => { if (data) setMeta(data); setLoading(false); });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { meta, loading };
}
